// extracted by mini-css-extract-plugin
module.exports = {"drip":"button-drip_drip_-12JB"};